// removed by extract-text-webpack-plugin
module.exports = {"loaderWrap":"_1A2vL","paymentsWidget":"_2b2Bc","generalError":"_3L8XX","generalErrorContent":"scsR9","generalErrorText":"_2INEq","circleIcon":"_1xYp5","title":"_294ns","methodsList":"_2tYgy","methodsListItem":"_1JWBE","hide":"_1vUz3"};


//////////////////
// WEBPACK FOOTER
// ./components/CashierPaymentsWidget/CashierPaymentsWidget.scss
// module id = 269
// module chunks = 0 1